/**
 * Chapter index for navigation
 * Contains minimal metadata for all textbook chapters to keep bundle size small
 */

export interface ChapterIndexItem {
  id: string;
  title: string;
  topic: string;
}

export interface TopicInfo {
  id: string;
  title: string;
  emoji: string;
  description: string;
}

export const topics: TopicInfo[] = [
  {
    id: 'filosofie',
    title: 'Filosofie',
    emoji: '🤔',
    description: 'Vědění jak žít – jak obstát v tomto světě'
  },
  {
    id: 'psychologie',
    title: 'Psychologie',
    emoji: '🧠',
    description: 'Věda o chování a prožívání člověka'
  },
  {
    id: 'sociologie',
    title: 'Sociologie',
    emoji: '👥',
    description: 'Studium společnosti a sociálních vztahů'
  },
  {
    id: 'pravo',
    title: 'Právo',
    emoji: '⚖️',
    description: 'Právní systém a ústavní principy'
  },
  {
    id: 'politologie',
    title: 'Politologie',
    emoji: '🏛️',
    description: 'Vše o politice, státech a mezinárodních vztazích'
  },
  {
    id: 'ekonomie',
    title: 'Ekonomie',
    emoji: '💰',
    description: 'Základy ekonomie a hospodářské politiky'
  },
  {
    id: 'evropska-unie',
    title: 'Evropská unie',
    emoji: '🇪🇺',
    description: 'Instituce a smlouvy EU'
  },
  {
    id: 'moderni-historie',
    title: 'Moderní historie',
    emoji: '🏰',
    description: 'Vše co scio chce k moderní historii'
  }
];

export const chaptersIndex: ChapterIndexItem[] = [
// --- Filozofie ---
{ id: 'ceska-filozofie-kapitola', title: 'Česká filozofie', topic: 'filosofie'},
 {id: 'filosoficke-smery', title:'Základní filosofické směry',topic:'filosofie'},
  {id: 'logika-argumentace', title:'Logika a argumentace',topic:'filosofie'},
  {id: 'filosofie-vedy', title:'Filosofie vědy',topic:'filosofie'},
  {id: 'etika-moralka', title:'Etika a morálka',topic:'filosofie'},
  {id: 'epistemo-onto', title:'Epistemologie a ontologie',topic:'filosofie'},
  {id: 'religie', title:'Filozofie religií',topic:'filosofie'},


// --- Psychologie ---
{ id: 'chapter-social-psych-01-revised', title: 'Sociální psychologie', topic: 'psychologie' },
{ id: 'chapter-psych-schools-01', title: 'Psychologické směry a přístupy', topic: 'psychologie' },
{ id: 'psychopatologie-a-poruchy-v2-full', title: 'Psychopatologie a poruchy', topic: 'psychologie' },
{ id: 'vyvojove-teorie', title: 'Vývojové teorie', topic: 'psychologie' },
{ id: 'kognitivni-procesy', title: 'Kognitivní procesy', topic: 'psychologie' },
{ id: 'psychoterapeuticke-metody', title: 'Psychoterapeutické metody', topic: 'psychologie' },
{ id: 'uvod-do-psychologie', title: 'Úvod do psychologie', topic: 'psychologie' },

{ id: 'inteligence-a-typologie-osobnosti', title: 'Inteligence a typologie osobnosti', topic: 'psychologie' },
{ id: 'struktury-vedomi-a-nevedomi', title: 'Struktury vědomí a nevědomí', topic: 'psychologie' },
{ id: 'podminovani-a-uceni', title: 'Podmiňování a učení', topic: 'psychologie' },

// --- Sociologie ---
{ id: 'soc-vyzkum-metody-pojmy', title: 'Metody a pojmy v sociologickém výzkumu', topic: 'sociologie' },
{ id: 'kultura-a-socializace', title: 'Kultura a socializace', topic: 'sociologie' },
{ id: 'vznik-a-vyvoj-sociologie', title: 'Vznik a vývoj sociologie', topic: 'sociologie' },
{ id: 'socialni-struktura-role-deviace', title: 'Sociální struktura, role a deviace', topic: 'sociologie' },


// --- Právo ---
{ id: 'ustavni-pravo-principy', title: 'Ústavní právo', topic: 'pravo' },
{ id: 'trestni-pravo-zaklady', title: 'Trestní právo', topic: 'pravo' },
{ id: 'pracovni-pravo-kapitola-v3-final', title: 'Pracovní právo', topic: 'pravo' },
{ id: 'obcanske-pravo-kapitola-v2-final', title: 'Občanské právo', topic: 'pravo' },
{ id: 'pravni-proces-soudnictvi', title: 'Právní proces a soudnictví', topic: 'pravo' },
{ id: 'legislativni-procesy-regulace', title: 'Legislativní procesy a regulace', topic: 'pravo' },


// --- Politologie ---
{ id: 'd2b8c3e4-f5a6-4789-b0c1-d2e3f4a5b6c7', title: 'Politický systém České republiky', topic: 'politologie' },
{ id: 'e3c9d4f5-a6b7-4890-c1d2-e3f4a5b6c7d8', title: 'Mezinárodní organizace', topic: 'politologie' },
{ id: 'f4d0e5f6-b7c8-4901-d2e3-f4a5b6c7d8e9', title: 'Politické strany a stranické systémy', topic: 'politologie' },
{ id: 'g5e1f6a7-c8d9-5012-e3f4-g5a6b7c8d9f0', title: 'Mezinárodní vztahy a geopolitika', topic: 'politologie' },
{ id: 'h6f2g7b8-d9e0-6123-f4g5-h6b7c8d9f0g1', title: 'Politické systémy a režimy', topic: 'politologie' },
{ id: 'i7g3h8c9-e0f1-7234-g5h6-i7c8d9f0g1h2', title: 'Rozdělení moci a ústavní principy', topic: 'politologie' },
{ id: 'j8h4i9d0-f1g2-8345-h6i7-j8d9f0g1h2i3', title: 'Teorie státu a politické ideologie', topic: 'politologie' },
{ id: 'k9i5j0e1-g2h3-9456-i7j8-k9e0f1g2h3i4', title: 'Instituce a volební systémy', topic: 'politologie' },


// --- Ekonomie ---
{ id: 'zaklady-makro-mikro-ekonomie', title: 'Základy makroekonomie a mikroekonomie', topic: 'ekonomie' },
{ id: 'ekonomicke-proudy-historie', title: 'Základní myšlenkové proudy ekonomie napříč historií', topic: 'ekonomie' },
{ id: 'hospodarska-politika-cnb', title: 'Hospodářská politika a Česká národní banka', topic: 'ekonomie' },
{ id: 'penize-a-bankovnictvi', title: 'Peníze a bankovnictví', topic: 'ekonomie' },


// --- Evropská unie ---
{ id: 'evropska-integrace-kapitola', title: 'Historie a vývoj evropské integrace', topic: 'evropska-unie' },
{ id: 'pravo-eu-kapitola', title: 'Právo EU a současné výzvy', topic: 'evropska-unie' },
{ id: 'schengen-politiky-eu-kapitola', title: 'Schengen a hlavní politiky EU', topic: 'evropska-unie' },
{ id: 'euro-integrace-kapitola', title: 'Euro a hospodářská integrace', topic: 'evropska-unie' },
{ id: 'c1a9b2d3-e4f5-4678-9a0b-1c2d3e4f5a6b', title: 'Instituce a rozhodovací procesy EU', topic: 'evropska-unie' },


// --- Moderní historie ---
{ id: 'moderni-dejiny-kapitola', title: 'Moderní dějiny (1848-1918)', topic: 'moderni-historie' },
{ id: 'moderni-dejiny-2-kapitola-v2-final', title: 'Moderní dějiny (1918-1945)', topic: 'moderni-historie' },
{ id: 'moderni-dejiny-3-kapitola-v2-final', title: 'Moderní dějiny (po roce 1945)', topic: 'moderni-historie' },

];

